module.exports = __webpack_public_path__ + "img/default-avatar.1f6c2c9a.png";